import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AlertPageLayout from 'src/components/AlertPageLayout';
import { Typography } from '@material-ui/core';
import { LinkAccountSummary } from 'src/components/LinkAccountSummary';

const useStyles: any = makeStyles((theme: any) => ({
  hr: {
    backgroundColor: theme.palette.success['500'],
    border: 0,
    height: 1,
    margin: theme.spacing(2, 0),
  },
  bottomSection: {
    textAlign: 'center',
  },
}));

const LinkSuccess = () => {
  const classes = useStyles();

  return (
    <AlertPageLayout pageTitle='Success' variant='success'>
      <hr className={classes.hr} />
      <Typography variant='h5'>Summary</Typography>
      <LinkAccountSummary />
      <hr className={classes.hr} />
    </AlertPageLayout>
  );
};

export default LinkSuccess;
